var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isGroup && !_vm.storeId)?_c('group-room-meet-list'):_c('store-cld-lists')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }